import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopNavbarComponent } from '../navigation/top-navbar/top-navbar.component';
import { BottomNavbarComponent } from '../navigation/bottom-navbar/bottom-navbar.component';
import { TableComponent as StepTableComponent } from '../steps/table/table.component';
import { TableComponent as TaskTableComponent } from '../tasks/table/table.component';
import { TableComponent as ProjectTableComponent } from '../projects/table/table.component';
import { TableComponent as ClientsTableComponent } from '../clients/table/table.component';
import { TableComponent as PaymentsTableComponent } from '../payments/table/table.component';
import { TableComponent as TimeAndBillingTableComponent } from '../time-and-billing/table/table.component';
import { CommentsComponent } from '../comments/comments.component';
import { CollapsibleComponent } from '../collapsible/collapsible.component';
import { QuickCommentComponent } from '../comments/quick-add/quick-add.component';
import { ActivityLogComponent } from '../activity-log/activity-log.component';
import { ExplorerComponent } from '../files/explorer/explorer.component';
import { UploadComponent } from '../files/upload/upload.component';
import { SelectComponent as SelectTagComponent } from '../tags/select/select.component';
import { SelectComponent as SelectGroupComponent } from '../groups/select/select.component';
import { ManagerComponent as GroupManagerComponent } from '../groups/manager/manager.component';

import { ManageComponent as ManageTagComponent } from '../tags/manage/manage.component';
import { TableModule } from 'primeng/table';
import { PickListModule } from 'primeng/picklist';
import { RouterModule } from '@angular/router';

import { NgxFilesizeModule } from 'ngx-filesize';
import { NgxFileDropModule } from 'ngx-file-drop';

import { ProgressBarModule } from 'primeng/progressbar';
import { SkeletonModule } from 'primeng/skeleton';
import { PipesModule } from '../../pipes/pipes.module'

import { FormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { SearchItemComponent } from '../search/item/item.component';


import { GanttComponent } from '../gantt/gantt.component';

import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { OverlayPanelModule } from 'primeng/overlaypanel';

import { CalendarComponent } from '../team-members/calendar/calendar.component';
import { CalendarComponent as AppCalendarComponent } from '../calendar/calendar.component';
import { CreateComponent as AppointmentCreateComponent } from '../team-members/calendar/appointments/create/create.component';
import { SetupComponent as SetupCalendarComponent } from '../team-members/calendar/setup/setup.component';
import { TimeSlotComponent as TimeSlotComponent } from '../team-members/calendar/time-slot/time-slot.component';
import { EditComponent as TimeSlotEditComponent } from '../team-members/calendar/time-slot/edit/edit.component'
import { TableComponent as TeamMemberTableComponent } from '../team-members/table/table.component'

import { CreateComponent as TeamMemberCreateComponent } from '../team-members/create/create.component';
import { DetailsComponent as TeamMemberDetailsComponent } from '../team-members/details/details.component';
import { ChangeCredentialsComponent } from '../team-members/details/change-credentials.component';
import { ChangePasswordComponent } from '../team-members/details/change-password.component';
import { DisableTwoFactorComponent } from '../team-members/details/disable-two-factor.component';


import { TableComponent as CompaniesTableComponent } from '../companies/table/table.component';

import { TableComponent as BillingGroupsTable } from '../billing_groups/table/table.component';

import { FullCalendarModule } from "@fullcalendar/angular";

import { CreateComponent as StepCreateComponent } from '../steps/create/create.component';
import { EmailFilesPromptComponent } from '../steps/email-files-prompt/email-files-prompt.component';
import { TaskEmailFilesComponent } from '../steps/task-email-files/task-email-files.component';
import { ChecklistItemsPreviewComponent } from '../steps/checklist-items-preview/checklist-items-preview.component';
import { MemberPickerModule } from '../team-members/member-picker/member-picker.module';
import { TaskDatesComponent } from '../tasks/task-dates/task-dates.component';
import { CreateComponent as GroupCreateComponent } from '../groups/create/create.component';


import { SelectCompanyRoleComponent } from '../address-book/select-company-role/select-company-role.component';
import { SearchComponent } from '../search/search.component';

import { RepeatRulesComponent } from '../repeat-rules/repeat-rules.component';
import { DyanmicFieldsComponent } from '../dyanmic-fields/dyanmic-fields.component';
import { AddressBookComponent } from '../address-book/address-book.component';
import { ContextMenuModule } from 'primeng/contextmenu';
import { QuillModule } from 'ngx-quill';
import { SelectPageModule } from 'src/app/team-members/select/select.module';
import { CreatePageModule as TimeAndBillingCreatePageModule } from 'src/app/time-and-billing/create/create.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { VirtualScrollerModule } from 'primeng/virtualscroller';

import { TemplateBookComponent } from '../projects/template-book/template-book.component';
import { ColumnPickerComponent } from '../tables/column-picker/column-picker.component';
import { FilterPresetsComponent } from '../tables/filter-presets/filter-presets.component';
import { MissingInfoTableComponent } from '../missing-info/table/table.component';
import { StickyScrollbarDirective } from '../../directives/sticky-scrollbar.directive';
import { UpdateRelatedProjectsComponent } from "../projects/update-related-projects/update-related-projects.component";
import { ResizableColumnsDirective } from '../../directives/resizable-columns.directive';
import { EmailTableComponent } from '../secure-email/table/table.component';
import { ManageRolesComponent } from '../roles/manage/manage.component';
import { ClientSchedulePreviewComponent } from '../projects/client-schedule-preview/client-schedule-preview.component';
import { ScheduleChangedProjectsComponent } from '../projects/schedule-changed-projects/schedule-changed-projects.component';
import { DeletedCompaniesPage } from '../../modals/deleted-companies/deleted-companies.page';
import { DeletedClientsPage } from '../../modals/deleted-clients/deleted-clients.page';
import { EmailPreviewComponent } from '../email-preview/email-preview.component';
import { DescriptionDropdownModule } from '../description-dropdown/description-dropdown.module';
import { ManageSkillsComponent } from '../team-members/manage-skills/manage-skills.component';
import { HealthSettingsComponent } from '../projects/health-settings/health-settings.component';
import { ManageComponent as ManageCustomFieldsComponent } from '../custom-fields/manage/manage.component';
import { TodoTableComponent } from '../todos/table/todo-table.component';
import { TodoSelectComponent } from '../todos/select/select.component';
import { TaskSelectComponent } from '../tasks/select/select.component';
import { MissingInfoSelectComponent } from '../missing-info/select/select.component';
import { TodoEditComponent } from '../todos/edit/todo-edit.component';


@NgModule({
  declarations: [
    TopNavbarComponent,
    BottomNavbarComponent,
    StepTableComponent,
    TaskTableComponent,
    ProjectTableComponent,
    CommentsComponent,
    CollapsibleComponent,
    QuickCommentComponent,
    ActivityLogComponent,
    ClientsTableComponent,
    ExplorerComponent,
    UploadComponent,
    SelectTagComponent,
    ManageTagComponent,
    SelectGroupComponent,
    GroupManagerComponent,
    SearchItemComponent,
    PaymentsTableComponent,
    GanttComponent,
    TimeAndBillingTableComponent,
    CalendarComponent,
    AppointmentCreateComponent,
    SetupCalendarComponent,
    TimeSlotComponent,
    TimeSlotEditComponent,
    TeamMemberTableComponent,
    TeamMemberCreateComponent,
    TeamMemberDetailsComponent,
    CompaniesTableComponent,
    BillingGroupsTable,
    StepCreateComponent,
    SearchComponent,
    RepeatRulesComponent,
    DyanmicFieldsComponent,
    AddressBookComponent,
    GroupCreateComponent,
    SelectCompanyRoleComponent,
    TemplateBookComponent,
    ColumnPickerComponent,
    FilterPresetsComponent,
    AppCalendarComponent,
    MissingInfoTableComponent,
    StickyScrollbarDirective,
    UpdateRelatedProjectsComponent,
    ResizableColumnsDirective,
    EmailTableComponent,
    ManageRolesComponent,
    ClientSchedulePreviewComponent,
    ScheduleChangedProjectsComponent,
    DeletedCompaniesPage,
    DeletedClientsPage,
    ChangeCredentialsComponent,
    ChangePasswordComponent,
    DisableTwoFactorComponent,
    EmailPreviewComponent,
    ManageSkillsComponent,
    HealthSettingsComponent,
    ManageCustomFieldsComponent,
    EmailFilesPromptComponent,
    TaskEmailFilesComponent,
    ChecklistItemsPreviewComponent,
    TodoTableComponent,
    TodoEditComponent,
    TodoSelectComponent,
    TaskSelectComponent,
    MissingInfoSelectComponent,
    TaskDatesComponent
  ],
  imports: [
    DescriptionDropdownModule,
    MemberPickerModule,
    RouterModule,
    CommonModule,
    TableModule,
    PickListModule,
    ProgressBarModule,
    SkeletonModule,
    PipesModule,
    FormsModule,
    NgxFilesizeModule,
    NgxFileDropModule,
    MultiSelectModule,
    DropdownModule,
    CalendarModule,
    OverlayPanelModule,
    FullCalendarModule,
    ContextMenuModule,
    QuillModule,
    DragDropModule,
    VirtualScrollerModule,
    SelectPageModule,
    TimeAndBillingCreatePageModule
  ],
  exports: [
    DescriptionDropdownModule,
    MemberPickerModule,
    TopNavbarComponent,
    BottomNavbarComponent,
    StepTableComponent,
    TaskTableComponent,
    ProjectTableComponent,
    CommentsComponent,
    CollapsibleComponent,
    QuickCommentComponent,
    ActivityLogComponent,
    ClientsTableComponent,
    ExplorerComponent,
    UploadComponent,
    SelectTagComponent,
    ManageTagComponent,
    SelectGroupComponent,
    GroupManagerComponent,
    SearchItemComponent,
    PaymentsTableComponent,
    GanttComponent,
    TimeAndBillingTableComponent,
    CalendarComponent,
    AppointmentCreateComponent,
    SetupCalendarComponent,
    TimeSlotComponent,
    TimeSlotEditComponent,
    TeamMemberTableComponent,
    TeamMemberCreateComponent,
    TeamMemberDetailsComponent,
    CompaniesTableComponent,
    BillingGroupsTable,
    StepCreateComponent,
    SearchComponent,
    RepeatRulesComponent,
    DyanmicFieldsComponent,
    AddressBookComponent,
    GroupCreateComponent,
    SelectCompanyRoleComponent,
    TemplateBookComponent,
    ColumnPickerComponent,
    FilterPresetsComponent,
    AppCalendarComponent,
    MissingInfoTableComponent,
    StickyScrollbarDirective,
    UpdateRelatedProjectsComponent,
    ResizableColumnsDirective,
    EmailTableComponent,
    ManageRolesComponent,
    ClientSchedulePreviewComponent,
    ScheduleChangedProjectsComponent,
    DeletedCompaniesPage,
    DeletedClientsPage,
    EmailPreviewComponent,
    ManageSkillsComponent,
    HealthSettingsComponent,
    ManageCustomFieldsComponent,
    EmailFilesPromptComponent,
    TaskEmailFilesComponent,
    ChecklistItemsPreviewComponent,
    TodoTableComponent,
    TodoEditComponent,
    TaskDatesComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class SharedModule { }
